<div class="fullscreen-confirmation">
  <div class="custom-confirmation" color="bg-success">
    <div class="custom-confirmation-content">
      <p class="confirmation-text">{{ message }}</p>

      <div class="d-flex justify-content-end">
        @if (showCancel || showConfirm) {
          <div class="d-flex justify-content-end w-100">
            @if (showCancel) {
              <button
                type="button"
                (click)="close()"
                mat-stroked-button
                color="warn"
                class="button cancel"
              >
                Cancelar
              </button>
            }
            @if (showConfirm) {
              <button
                type="button"
                (click)="confirm()"
                class="button change-profile cardWithShadow"
              >
                Confirmar
              </button>
            }
          </div>
        }
      </div>
    </div>
  </div>
</div>
